module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contribute"
  }, [_c('section', {
    staticClass: "hero is-fullheight is-white sui-contribute"
  }, [_c('div', {
    staticClass: "hero-head sui-contribute-header"
  }, [_c('bar', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bar-content",
    slot: "left"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bar-content",
    slot: "right"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.contributeContent
    }
  }, [_vm._v("\n                  POST\n                ")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caption),
      expression: "caption"
    }],
    ref: "caption",
    staticClass: "textarea",
    attrs: {
      "placeholder": "Type a caption"
    },
    domProps: {
      "value": (_vm.caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddImages
    },
    on: {
      "click": _vm.addAttachmentImage
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddVideos
    },
    on: {
      "click": _vm.addAttachmentVideo
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": !_vm.canAddLinks
    },
    on: {
      "click": _vm.addAttachmentLink
    }
  }, [_vm._m(2)])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-center"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": _vm.addHashTag
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    on: {
      "click": _vm.addMention
    }
  }, [_vm._m(5)])])])])])]), _vm._v(" "), _c('transition-group', {
    staticClass: "columns is-mobile attachment-preview",
    attrs: {
      "name": "attachments",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "tag": "div"
    }
  }, [_vm._l((_vm.attachmentList), function(attachment, $index) {
    return [(attachment.type === 'image' || attachment.type === 'video') ? _c('div', {
      key: $index,
      staticClass: "column has-text-centered"
    }, [_c('div', {
      staticClass: "image is-128x128"
    }, [_c('img', {
      attrs: {
        "src": attachment.url
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "button is-danger is-outlined",
      on: {
        "click": function($event) {
          _vm.removeAttachment($index)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('span', [_vm._v("\n                  REMOVE\n                ")])])]) : _vm._e(), _vm._v(" "), (attachment.type === 'link') ? _c('div', {
      key: $index,
      staticClass: "column is-offset-3-tablet is-half-tablet has-text-centered"
    }, [_c('article', {
      staticClass: "media",
      staticStyle: {
        "min-height": "128px"
      }
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64"
    }, [_c('img', {
      attrs: {
        "src": attachment.imageUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(attachment.url))]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(attachment.caption) + "\n                    ")])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('a', {
      staticClass: "button is-danger is-outlined",
      on: {
        "click": function($event) {
          _vm.removeAttachment($index)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('span', [_vm._v("\n                  REMOVE\n                ")])])]) : _vm._e()]
  }), _vm._v(" "), _vm._l((6), function(n) {
    return (!_vm.attachmentListType || _vm.attachmentListType !== 'link') ? _c('div', {
      key: 'ghost-' + n,
      staticClass: "column"
    }) : _vm._e()
  })], 2)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-film"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-white",
    attrs: {
      "disabled": ""
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-at"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-654801c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contribute.vue
// module id = 286
// module chunks = 1